import { BrandfolderHexColors } from '../enums/colors.js';

const defaultAlert = {
    backgroundColor: 'transparent',
    borderColor: 'transparent',
    iconColor: BrandfolderHexColors.Text,
    iconColorHover: BrandfolderHexColors.Title,
    textColor: BrandfolderHexColors.Text,
    textColorInline: BrandfolderHexColors.Text
};
const defaultAlertDark = {
    backgroundColor: 'transparent',
    borderColor: 'transparent',
    iconColor: BrandfolderHexColors.White,
    iconColorHover: BrandfolderHexColors.Gray,
    textColor: BrandfolderHexColors.White,
    textColorInline: BrandfolderHexColors.White
};
const errorAlert = {
    backgroundColor: '#FFE3E4',
    borderColor: '#FE999C',
    iconColor: BrandfolderHexColors.Delete,
    iconColorHover: '#9D0214',
    textColor: BrandfolderHexColors.Text,
    textColorInline: BrandfolderHexColors.Delete
};
const errorAlertDark = {
    backgroundColor: 'transparent',
    borderColor: '#FE999C',
    iconColor: BrandfolderHexColors.Delete,
    iconColorHover: '#9D0214',
    textColor: BrandfolderHexColors.White,
    textColorInline: BrandfolderHexColors.Delete
};
const successAlert = {
    backgroundColor: '#D3F9E7',
    borderColor: '#77EDB6',
    iconColor: '#00A042',
    iconColorHover: '#006D2D',
    textColor: BrandfolderHexColors.Text,
    textColorInline: '#00A042'
};
const successAlertDark = {
    backgroundColor: 'transparent',
    borderColor: '#77EDB6',
    iconColor: '#00A042',
    iconColorHover: '#006D2D',
    textColor: BrandfolderHexColors.White,
    textColorInline: '#00A042'
};
const warningAlert = {
    backgroundColor: '#FFF7DC',
    borderColor: '#FFE796',
    iconColor: '#D39F00',
    iconColorHover: '#A07900',
    textColor: BrandfolderHexColors.Text,
    textColorInline: '#D39F00'
};
const warningAlertDark = {
    backgroundColor: 'transparent',
    borderColor: '#FFE796',
    iconColor: '#D39F00',
    iconColorHover: '#A07900',
    textColor: BrandfolderHexColors.White,
    textColorInline: '#D39F00'
};

export { defaultAlert, defaultAlertDark, errorAlert, errorAlertDark, successAlert, successAlertDark, warningAlert, warningAlertDark };
//# sourceMappingURL=alert.js.map
